<template>
  <span class="ysc-highlight underline decoration-orange-200 decoration-8 underline-offset-[-4px]">
    <slot />
  </span>
</template>

<style scoped>
.ysc-highlight {
    text-decoration-skip-ink: none;
}
</style>
